export class ColorService {
    static readonly StatusmatcherColor = '#A00';
    static readonly StatusmatcherColorLight = '#ECC';
    static readonly StatusmatcherGrey = '#C4C4C4';
    static readonly StatusmatcherTextColor = '#212529'
}